import React from "react";
import get from "lodash/get";
import { orderBy, find, omit, groupBy, startCase, debounce } from "lodash";
import { connect } from "react-redux";
import {
  Alert,
  Layout,
  Table,
  Breadcrumb,
  Collapse,
  Input,
  Button,
  Select, InputNumber,
} from "antd";


import Footer from "../../components/Footer/Footer";
import classes from "./SettingsTranslations.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  listTranslationsAdmin,
  updateTranslation,
  exportTranslations,
  importTranslations,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import { LoadingOutlined } from "@ant-design/icons";
import i18n from "../../i18n";
import { TRANSLATIONS_STORAGE_KEY } from "../../constants";
import { getLanguages, getUserInfo } from "../../reducers/user/selectors";
import map from "lodash/map";
import filter from "lodash/filter";
import cloneDeep from "lodash/cloneDeep";

const { Content } = Layout;
const { Search } = Input;
const { Panel } = Collapse;

function debounceEventHandler(...args) {
  const debounced = debounce(...args);

  return function (e) {
    return debounced(e);
  };
}

const namespacesMap = {
  translation: "Global",
};

const formatNamespace = (namespace) =>
  startCase(namespace.replace("Namespace", ""));

const Accordion = ({ children, label, isOpen, onClick }) => (
  <div>
    <button
      style={{
        outline: "none",
        padding: "1rem",
        borderBottom: "1px solid #bbb",
        borderTop: 0,
        borderLeft: 0,
        borderRight: 0,
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        background: "transparent",
        cursor: "pointer",
        fontWeight: "500",
      }}
      onClick={onClick}
    >
      {label}
      <svg
        style={{
          width: "1rem",
          height: "1rem",
          color: "#aaa",
          transform: isOpen ? "rotate(180deg)" : null,
        }}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>
    {isOpen && <div>{children}</div>}
  </div>
);

class SettingsTranslations extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      translations: [],
      editedTranslations: {},
      loadingTranslations: {},
      errorMessage: "",
      responseMessage: "",
      activeAccordion: null,
      settingsEdit: null,
      additionalTranslationsLoading: false,
      additionalTranslations: [],
      editedAdditionalTranslations: {},
      loadingAdditionalTranslations: {},
      exportLoading: false,
      importLoading: false,
      imported: false,
      filtersBy: [],
      filtersValue: [],
      nameSearch: null,
      moduleSearch: null,
    };
  }

  async componentDidMount() {
    this.getTranslations();

    const secondLang =  get(this.props.languages.filter((language) => language.code !== "en"), '[0]');

    if (secondLang) {
      this.onAdditionalLanguageChange(secondLang.id);
    }
  }

  onNameSearch = async (value) => {
    this.setState(
      {
        nameSearch: value,
      },
      this.getTranslations
    );
  };


  getTranslations = debounce(async () => {
    const {
      filtersBy,
      filtersValue
    } = this.state;

    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    const keyIndex = filtersBy.indexOf('key');
    const moduleIndex = filtersBy.indexOf('module');
    const valueIndex = filtersBy.indexOf('value');

    try {
      let key = filtersValue[keyIndex];
      let module = filtersValue[moduleIndex];
      let value = filtersValue[valueIndex];
      if (key && key.length < 2){
        key = '';
      }
      if (module && module.length < 2){
        module = '';
      }
      if (value && value.length < 2){
        value = '';
      }

      const { data } = await listTranslationsAdmin({ locale: "en", key: key, module: module, value: value });

      this.setState({
        translations: groupBy(orderBy(data, "module"), "module"),
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  }, 200);

  handleChangeDebounced = debounce(async function (
    e,
    namespace,
    key,
    language = null
  ) {
    const id = `${namespace}-${key}`;

    const editedKey = language
      ? "editedAdditionalTranslations"
      : "editedTranslations";

    this.setState({
      [editedKey]: {
        ...this.state[editedKey],
        [id]: e.target.value,
      },
    });
  },
  100);

  handleChange(namespace, key, language = null) {
    return (e) => {
      e.persist();

      this.handleChangeDebounced(e, namespace, key, language);
    };
  }

  async updateTranslation(namespace, key, language = undefined) {
    const id = `${namespace}-${key}`;

    const editedKey = language
      ? "editedAdditionalTranslations"
      : "editedTranslations";
    const loadingKey = language
      ? "loadingAdditionalTranslations"
      : "loadingTranslations";
    const translationsKey = language
      ? "additionalTranslations"
      : "translations";

    const fetchedLanguage = this.props.languages.find(
      (item) => item.code === (language || "en")
    );

    await updateTranslation(
      namespace,
      key,
      this.state[editedKey][id],
      fetchedLanguage.id
    );

    const cachedTranslations = JSON.parse(
      window.localStorage.getItem(TRANSLATIONS_STORAGE_KEY)
    );

    if (cachedTranslations) {
      window.localStorage.setItem(
        TRANSLATIONS_STORAGE_KEY,
        JSON.stringify(
          cachedTranslations.map((item) =>
            item.module === namespace && item.key === key
              ? {
                  ...item,
                  value: this.state[editedKey][id],
                }
              : item
          )
        )
      );
    }

    const userLanguage = this.props.userInfo.language
      ? this.props.languages.find(
          (item) => this.props.userInfo.language === item.id
        )
      : null;

    if (userLanguage && userLanguage.code === fetchedLanguage.code) {
      i18n.addResourceBundle(fetchedLanguage.code, namespace, {
        [key]: this.state[editedKey][id],
      });
    }

    this.setState({
      [editedKey]: omit(this.state[editedKey], id),
      [loadingKey]: omit(this.state[loadingKey], id),
      [translationsKey]: {
        ...this.state[translationsKey],
        [namespace]: this.state[translationsKey][namespace]
          ? this.state[translationsKey][namespace].map((item) =>
              item.module === namespace && item.key === key
                ? { ...item, value: this.state[editedKey][id] }
                : item
            )
          : [{ module: namespace, key, value: this.state[editedKey][id] }],
      },
    });
  }

  exportTranslations = async () => {
    this.setState({
      exportLoading: true,
    });

    try {
      const { data } = await exportTranslations();

      const a = document.createElement("a");

      a.href = URL.createObjectURL(
        new Blob([JSON.stringify(data, null, 2)], {
          type: "text/plain",
        })
      );

      a.setAttribute("download", "translations.json");

      document.body.appendChild(a);

      a.click();

      document.body.removeChild(a);
    } finally {
      this.setState({
        exportLoading: false,
      });
    }
  };

  importTranslations = async () => {
    const input = document.createElement("input");

    input.type = "file";

    input.click();

    input.onchange = async (e) => {
      this.setState({
        importLoading: true,
      });
      try {
        const formData = new FormData();

        formData.append("file", e.target.files[0]);

        await importTranslations(formData);
      } finally {
        this.setState({
          importLoading: false,
          imported: true,
        });
      }
    };
  };

  async onAdditionalLanguageChange(value) {
    this.setState({
      additionalLanguage: value,
      additionalTranslationsLoading: true,
      additionalTranslations: [],
    });

    const language = this.props.languages.find((item) => item.id === value);

    const { data } = await listTranslationsAdmin({ locale: language.code });

    this.setState({
      additionalTranslations: groupBy(orderBy(data, "module"), "module"),
      additionalTranslationsLoading: false,
    });
  }

  columns() {
    return [
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t("NamespaceSettingsTranslations:Original"),
        render: (val, record) => record.key,
        width: "33%",
      },
      {
        dataIndex: "value",
        key: "value",
        title:
          this.props.i18n.t("NamespaceSettingsTranslations:Translation") +
          " English",
        width: "33%",
        render: (val, record) => {
          const id = [`${record.module}-${record.key}`];

          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Input.TextArea
                name="value"
                defaultValue={record.value}
                onChange={this.handleChange(record.module, record.key)}
              />
              {this.state.editedTranslations[id] &&
                this.state.editedTranslations[id] !== record.value && (
                  <Button
                    loading={this.state.loadingTranslations[id]}
                    disabled={this.state.loadingTranslations[id]}
                    onClick={() =>
                      this.updateTranslation(record.module, record.key)
                    }
                    style={{ marginLeft: "1rem", width: '80px' }}
                  >
                    {this.props.i18n.t("Save")}
                  </Button>
                )}
            </div>
          );
        },
      },
      ...(this.props.languages.length > 1
        ? [
            {
              dataIndex: "additionalLanguage",
              key: "additionalLanguage",
              title: (
                <div>
                  <Select
                    onChange={(value) => this.onAdditionalLanguageChange(value)}
                    value={
                      this.state.additionalLanguage
                        ? this.state.additionalLanguage
                        : undefined
                    }
                    placeholder={this.props.i18n.t("Language")}
                    style={{ width: "10rem" }}
                    disabled={this.state.additionalTranslationsLoading}
                    loading={this.state.additionalTranslationsLoading}
                  >
                    {this.props.languages
                      .filter((language) => language.code !== "en")
                      .map((language) => (
                        <Select.Option key={language.id} value={language.id}>
                          {language.name}
                        </Select.Option>
                      ))}
                  </Select>
                </div>
              ),
              render: (val, record) => {
                const id = [`${record.module}-${record.key}`];

                if (
                  !this.state.additionalLanguage ||
                  this.state.additionalTranslationsLoading
                ) {
                  return null;
                }

                const value = get(
                  find(
                    this.state.additionalTranslations[record.module],
                    ({ key }) => key === record.key
                  ),
                  "value"
                );

                return (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Input.TextArea
                      name="value"
                      defaultValue={value}
                      onChange={this.handleChange(
                        record.module,
                        record.key,
                        this.state.additionalLanguage
                      )}
                    />
                    {this.state.editedAdditionalTranslations[id] &&
                      this.state.editedAdditionalTranslations[id] !== value && (
                        <Button
                          loading={this.state.loadingAdditionalTranslations[id]}
                          disabled={
                            this.state.loadingAdditionalTranslations[id]
                          }
                          onClick={() =>
                            this.updateTranslation(
                              record.module,
                              record.key,
                              this.props.languages.find(
                                (item) =>
                                  item.id === this.state.additionalLanguage
                              ).code
                            )
                          }
                          style={{ marginLeft: "1rem", width: '80px' }}
                        >
                          {this.props.i18n.t("Save")}
                        </Button>
                      )}
                  </div>
                );
              },
              width: "33%",
            },
          ]
        : []),
    ];
  }

  clearFilter = (index) => () => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);

      filtersBy.splice(index, 1);
      filtersValue.splice(index, 1);

      return { filtersBy, filtersValue, currentPage: 1 };
    }, this.getTranslations);
  };


  handleCustomFilterChange = (index) => (value) => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);

      filtersBy[index] = value;
      delete filtersValue[index]; // TODO: null?

      return { filtersBy, filtersValue };
    });
  };

  handleCustomFilterValueChange = (index) => (val) => {
    this.setState((state) => {
      const filtersValue = cloneDeep(state.filtersValue);
      filtersValue[index] = val;
      return { filtersValue, currentPage: 1 };
    }, this.getTranslations);
  };


  renderFilterItem = (index = this.state.filtersBy.length) => {
    const {
      filtersBy,
      filtersValue,
    } = this.state;

    return (
      <div className={classes.wrapperFilterItem} key={filtersBy[index]}>
        <div className={classes.searchWrapperFilter}>
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Search by")}
            </b>
            <Select
              onChange={this.handleCustomFilterChange(index)}
              value={filtersBy[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              <Select.Option value={`key`} disabled={filtersBy.includes('key')}>
                {this.props.i18n.t("NamespaceSettingsTranslations:Key")}
              </Select.Option>
              <Select.Option value={`module`} disabled={filtersBy.includes('module')}>
                {this.props.i18n.t("NamespaceSettingsTranslations:Module")}
              </Select.Option>
              <Select.Option value={`value`} disabled={filtersBy.includes('value')}>
                {this.props.i18n.t("NamespaceSettingsTranslations:Value")}
              </Select.Option>
            </Select>
          </label>
        </div>

        {filtersBy[index] && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>{this.props.i18n.t("NamespaceSettingsTranslations:Value")}</b>
            <Input
              disabled={!filtersBy[index]}
              onChange={(e) => {
                this.handleCustomFilterValueChange(index)(
                  get(e, "target.value")
                );
              }}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("NamespaceSettingsTranslations:Value")}
            />
          </label>
        )}

        {filtersValue[index] && (
          <span
            className={classes.clearButton}
            onClick={this.clearFilter(index)}
          >
            {this.props.i18n.t("NamespaceSettingsTranslations:Remove")}
          </span>
        )}
      </div>
    );
  };


  render() {
    const {
      translations,
      errorMessage,
      responseMessage,
      isLoading,
      nameSearch,
      moduleSearch,
    } = this.state;

    return (
      <div>
        <Layout className={classes.parentContainer}>

          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t(
                "NamespaceSettingsTranslations:Localization Management"
              )}
            </h3>

            <Breadcrumb>
              <Breadcrumb.Item href="/admin/settings">
                {this.props.i18n.t("Admin Settings")}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {this.props.i18n.t(
                  "NamespaceSettingsTranslations:Translations"
                )}
              </Breadcrumb.Item>
            </Breadcrumb>
            <br />

            {errorMessage && <Alert type="error" message={errorMessage} />}

            {responseMessage && (
              <Alert type="success" message={responseMessage} />
            )}

            <div className={classes.customFiltersWrapper}>
              {this.state.filtersBy.map((_, index) => this.renderFilterItem(index))}

              {this.state.filtersBy.length === this.state.filtersValue.length &&
              this.state.filtersBy.length !== 3 &&
              this.renderFilterItem()}
            </div>

            {isLoading ? (
              <LoadingOutlined />
            ) : (
              <div>
                <div style={{ margin: "2rem 0 1rem" }}>
                  <Button
                    onClick={this.importTranslations}
                    loading={this.state.importLoading}
                    disabled={this.state.importLoading}
                    style={{ marginRight: "1rem" }}
                  >
                    {this.props.i18n.t("NamespaceSettingsTranslations:Import Translations")}
                  </Button>
                  <Button
                    onClick={this.exportTranslations}
                    loading={this.state.exportLoading}
                    disabled={this.state.exportLoading}
                  >
                    {this.props.i18n.t("NamespaceSettingsTranslations:Export Translations")}
                  </Button>
                </div>
                {this.state.imported && (
                  <Alert
                    type="success"
                    message={this.props.i18n.t(
                      "NamespaceSettingsTranslations:Translations import has started. Please come back in a few minutes."
                    )}
                  />
                )}
                {Object.keys(translations).map((namespace, index) => (
                  <Accordion
                    label={
                      namespacesMap[namespace] || formatNamespace(namespace)
                    }
                    key={index}
                    isOpen={this.state.activeAccordion === namespace}
                    onClick={() =>
                      this.setState({
                        activeAccordion:
                          this.state.activeAccordion === namespace
                            ? null
                            : namespace,
                      })
                    }
                  >
                    <Table
                      columns={this.columns()}
                      dataSource={translations[namespace]}
                      loading={isLoading}
                      rowKey={(item, index) =>
                        `${namespace}-${item.key}-${index}`
                      }
                      pagination={false}
                    />
                  </Accordion>
                ))}
              </div>
            )}
          </Content>

        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  languages: getLanguages(state),
  userInfo: getUserInfo(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SettingsTranslations))
);



// WEBPACK FOOTER //
// ./src/containers/SettingsTranslations/SettingsTranslations.js